<template>
  <i-select
    v-model="valueModel"
    :remote-method="search"
    :multiple="multiple"
    filterable
    remote
    clearable
    :disabled="disabled"
  >
    <i-option v-for="dataset in datasets" :key="dataset.id" :value="dataset.id">
      {{ dataset.name }}
    </i-option>
  </i-select>
</template>

<script>
import axios from "axios";
import { getTsQueryValue } from "@/utils/common";

export default {
  props: {
    value: { type: [Number, Array] },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      currentID: "",
      datasets: [],
    };
  },

  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    search(name) {
      if (name === "" || name.length < 3) return;
      const query = getTsQueryValue(name);

      axios
        .get("/psql/tabular_datasets", {
          params: {
            select: "id,name",
            name: query,
            limit: 48,
          },
        })
        .then(response => {
          this.datasets = response.data;
        })
        .catch(error => {
          console.error(error.response);
        });
    },

    loadValue(value) {
      if (value) {
        let valueList = value;
        if (!Array.isArray(value)) {
          valueList = [value];
        }

        axios
          .get("/psql/tabular_datasets", {
            params: {
              select: "id, name",
              id: `in.(${valueList.join(",")})`,
            },
          })
          .then(response => {
            this.datasets = response.data;
          })
          .catch(error => {
            console.error(error.response);
          });
      }
    },
  },

  watch: {
    value(newValue) {
      this.loadValue(newValue);
    },
  },

  created() {
    this.loadValue(this.value);
  },
};
</script>
